<template>
    <div class="background">
        <div class="background-image">
        </div>
        <div class="login-container">
            <slot></slot>
        </div>
    </div>
</template>
